import styled from "styled-components";

export const AirportTripSelectorContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    margin-bottom: 4rem;
`;

export const AirportTripSelectorHeader = styled.div`
    color: #141823;
    margin-right: 28px;
`;

export const AirportTripSelectorContent = styled.div`
    display: flex;
`;

export const AirportTripSelector = styled.a`
    width: 224px;
    height: 68px;
    position: relative;
    display: flex;
    align-items: center;
    padding: 18px 16px;
    background-color: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.23);

    &:first-child {
        margin-right: 36px;
    }
`;

export const AirportTripSelectorTitle = styled.div`
    color: #141823;
    font-family: 'Rubik';
    font-size: 16px;
    font-weight: 600;
    margin-left: 16px;
`;

export const AirportTripSelectorSubTitle = styled.div`
    color: #4f525a;
    font-size: 14px;
    margin-left: 16px;
`;

export const AirportTripSelectorActive = styled.div`
    position: absolute;
    right: -8px;
    top: -8px;
    border-radius: 50%;
    height: 24px;
    width: 24px;
    background-color: #2276e3;
    color: #fff;
    padding: 2px 6px 0;
    font-size: 16px;
`;